import { ListItemProps, default as MuiListItem } from '@mui/material/ListItem'

const ListItem = (props: ListItemProps) => {
  return <MuiListItem {...props} />
}

export default ListItem
